import {Pipe, PipeTransform} from "@angular/core";
import dayjs from "dayjs";
@Pipe({
	name: "mmss",
	standalone: false,
})
export class MmssPipe implements PipeTransform {
	transform(milliseconds: number, args?: any) {
		if (milliseconds) {
			// 2017-09-18, Alex
			// milliseconds fixed. One zero too much.
			if (milliseconds >= 3601000) {
				// 1h
				return dayjs().startOf("day").millisecond(milliseconds).format("HH:mm:ss");
			} else {
				return dayjs().startOf("day").millisecond(milliseconds).format("mm:ss");
			}
		} else {
			return "00:00";
		}
	}
}
